import React, { useState, useEffect } from "react";

import axios from "axios";

import { Loading, PageListItem } from "../../components";
import { isMobile } from "react-device-detect";

const getPageWithTallImage = (pages) => {
  for (let i = 0; i < pages.length; i++) {
    if (pages[i].image2) {
      return pages[i];
    }
  }
};

const RecentNews = ({ className = "" }) => {
  const [pages, setPages] = useState();

  useEffect(() => {
    const loadData = async () => {
      const { data } = await axios.post("/api/pages/search", {
        sort: { field: "created_at", direction: "desc" },
        paging: { limit: 4, offset: 0 },
        type: "news",
      });

      setPages(data.items);
    };

    loadData();
  }, []);

  if (!pages) {
    return <Loading type="table" showText={false} />;
  }

  const tallOne = getPageWithTallImage(pages);
  const normalOnes = pages.filter((p) => p !== tallOne);

  if (tallOne) {
    return (
      <div className={`${isMobile ? "mx-0" : ""} row`}>
        <div className="col-lg-6">
          <PageListItem page={normalOnes[0]} showButton={false} height={419} />
          <PageListItem
            className="mt-3"
            page={normalOnes[1]}
            showButton={false}
            height={419}
          />
        </div>
        <div className="col-lg-6">
          <PageListItem
            className="tall d-none d-lg-block ms-3"
            height={852}
            page={tallOne}
            useAlternativeImage
            showButton={false}
          />
          <PageListItem
            className="mt-3 d-lg-none"
            height={419}
            page={tallOne}
            showButton={false}
          />
        </div>
      </div>
    );
  }

  return (
    <div className={`${isMobile ? "mx-0" : ""} row`}>
      <div className="col-lg-6">
        {normalOnes[0] && (
          <PageListItem
            className="mt-3"
            page={normalOnes[0]}
            showButton={false}
            height={419}
          />
        )}
        {normalOnes[2] && (
          <PageListItem
            className="mt-3"
            page={normalOnes[2]}
            showButton={false}
            height={419}
          />
        )}
      </div>

      <div className="col-lg-6">
        {normalOnes[1] && (
          <PageListItem
            className="mt-3 ms-lg-3"
            page={normalOnes[1]}
            showButton={false}
            height={419}
          />
        )}
        {normalOnes[3] && (
          <PageListItem
            className="mt-3 ms-lg-3"
            page={normalOnes[3]}
            showButton={false}
            height={419}
          />
        )}
      </div>
    </div>
  );
};

export default RecentNews;
